export default "/static/vaccine/list.png"